import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import CreateEventForm, { FormValues } from 'src/components/Event/EventManagement/CreateEventForm';
import { ApplicationState } from 'src/store';
import { alertError } from 'src/store/alert/actions';
import { getEventById, updateEvent } from 'src/store/events/actions';
import { CardEvent, CreateEventData, EventTypes, IEventData } from 'src/store/events/types';
import { getUsers } from 'src/store/user/action';
import { User } from 'src/store/user/types';

interface Props {
  updateEvent: typeof updateEvent;
  alertError: typeof alertError;
  loading: boolean;
  loadingImage: boolean;
  getUsers: any;
  guides: User[];
  eventData: IEventData;
  getEvent: typeof getEventById;
}

type Allprops = Props & RouteComponentProps<any>;

class EditEvent extends React.Component<Allprops> {
  eventId: number;

  constructor(props: Allprops) {
    super(props);

    this.eventId = +this.props.match.params.eventId;
  }

  componentDidMount() {
    this.props.getEvent(this.eventId);
  }

  onSubmit = (event: CreateEventData, file?: File) => {
    console.log(event);
    console.log(file);
    console.log('Formular submittiert');
    return this.props.updateEvent(event, file);
  };

  render() {
    const { eventData, loadingImage } = this.props;
    const event = eventData.byId[this.eventId];
    if (!event) {
      return null;
    }
    return (
      <React.Fragment>
        <h1>Gruppe {event.eventgroup.id} bearbeiten</h1>
        <CreateEventForm
          {...this.props}
          editMode={true}
          initialValues={this.generateInitialValue(event)}
          createEvent={this.props.updateEvent}
          eventgroupId={event.eventgroup.id}
          sectionTitle={event.section ? event.section.title : ''}
          loadingImage={loadingImage}
        />
      </React.Fragment>
    );
  }

  generateInitialValue = (event: CardEvent): FormValues => {
    const values: FormValues = {
      title: event.title,
      bikesAllowed: event.bikesAllowed,
      description: event.description.replace(new RegExp('<br />', 'g'), '\n'),
      dateranges: event.eventgroup.dateranges,
      quota: event.quota === null ? '' : event.quota,
      shortDescription: event.shortDescription.replace(new RegExp('<br />', 'g'), '\n'),
      weekDays: event.eventgroup.dateranges[0].weekdays
        ? event.eventgroup.dateranges[0].weekdays.map((val: number) => {
            return +val;
          })
        : [0],
      startTime: new Date(event.begins),
      familyFriendly: event.familyfriendly > 0 ? true : false,
      age: event.familyfriendly > 0 ? event.familyfriendly : '',
      price: event.price ? event.price : '',
      difficulty: event.difficulty,
      buses: event.buses ? event.buses : [],
      stations:
        event.buses && event.buses.length > 0 && event.buses[0].stations
          ? event.buses[0].stations
          : [],
      picture: undefined,
      guides: event.guides ? event.guides : [],
      eventType: event.bikesAllowed
        ? EventTypes.bikeBus
        : event.buses && event.buses.length > 0
        ? EventTypes.bus
        : EventTypes.default,
      meetingpoint: event.meetingpoint ? event.meetingpoint : '',
      duration: event.duration ? event.duration : '',
      currentImageUrl: event.image ? event.image.url : undefined
    };
    return values;
  };
}

const mapStateToProps = ({ events, users, image }: ApplicationState) => ({
  loading: events.loading,
  guides: users.users,
  eventData: events.data,
  loadingImage: image.loading
});

const mapDispatchToProps = (dispatch: any) => ({
  updateEvent: (event: CreateEventData, file?: File) => dispatch(updateEvent(event, file)),
  alertError: (err: Error) => dispatch(alertError(err)),
  getUsers: () => dispatch(getUsers('/type/Guide', undefined)),
  getEvent: (eventId: number) => dispatch(getEventById(eventId))
});

export default connect(mapStateToProps, mapDispatchToProps)(EditEvent);



// WEBPACK FOOTER //
// ./src/pages/Management/EventManagement/EditEvent.tsx